import {ProductInWarehousesReport} from "../models/Report";
import {ProductInWarehousesReportTemplateData} from "./ProductInWarehousesReportTemplateData";
import {ProductInWarehousesReportImportTemplate} from "./ProductInWarehousesReportImportTemplate";
import {cloneDeep} from "lodash";

export const getProductInWarehousesReportTemplate = (
    data: ProductInWarehousesReport[],
    selectedProduct: string,
    totalNeto: number,
    totalSrps: number
    ) => {
    return ProductInWarehousesReportImportTemplate(prepareData(data, selectedProduct, totalNeto, totalSrps));
};

const prepareData = (
    documentData: ProductInWarehousesReport[],
    selectedProduct: string,
    totalNeto: number,
    totalSrps: number
    ) => {
    const templateData: ProductInWarehousesReportTemplateData = {
        productName: selectedProduct,
        reportByDay: cloneDeep(documentData),
        totalNeto: totalNeto,
        totalSrps: totalSrps
    };

    return templateData;
};